import { AdminLayout } from '../components/AdminLayout';
import { ServerCrash, Clock } from 'lucide-react';

export default function StatusPage() {
  return (
    <AdminLayout title="Status & Outage" subtitle="État des services et monitoring">
      <div className="flex flex-col items-center justify-center py-24">
        <div className="relative mb-8">
          <div className="w-24 h-24 bg-gradient-to-br from-blue-100 to-cyan-100 dark:from-blue-900/20 dark:to-cyan-900/20 rounded-full flex items-center justify-center">
            <ServerCrash className="w-10 h-10 text-blue-500" />
          </div>
          <div className="absolute -top-2 -right-2 w-8 h-8 bg-amber-100 dark:bg-amber-900/30 rounded-full flex items-center justify-center">
            <Clock className="w-4 h-4 text-amber-500" />
          </div>
        </div>

        <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-3">Coming Soon</h2>
        <p className="text-gray-500 dark:text-gray-400 text-center max-w-md mb-6">
          Le monitoring des services et la gestion des incidents arrivent bientôt. Suivi des API,
          uptime, alertes et plans de backup seront disponibles ici.
        </p>

        <div className="flex items-center gap-2 bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 rounded-xl px-4 py-2.5">
          <Clock className="w-4 h-4 text-amber-600 dark:text-amber-400" />
          <span className="text-sm font-medium text-amber-700 dark:text-amber-300">
            En développement
          </span>
        </div>
      </div>
    </AdminLayout>
  );
}
